import { RouteRecordRaw } from 'vue-router'

export const BaseRoute: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: "/frontDesk/index"
  },
]

export default BaseRoute